import { MarketLayoutStylesSchema } from './MarketLayout.styles';

export const matchDetailsStyles: MarketLayoutStylesSchema = {
  headerText: {
    flex: '1',
    color: 'white',
    align: 'center',
    fontSize: '2xs',
    fontWeight: 'bold',
  },
  rowWrapper: {
    mx: '0.5',
    px: '4',
    py: '2',
    alignItems: 'center',
    display: 'flex',
    fontSize: 'xs',
    fontWeight: 'bold',
    justifyContent: 'space-between',
    borderColor: 'blackAlpha.400',
    borderBottomWidth: '1px',
    borderTopWidth: undefined,
    gap: '2',
    pos: 'relative',
    boxShadow: '0 1px rgba(255, 255, 255, .07)',
    color: 'white',
  },
  rowWrapperFirst: {
    borderTopWidth: '1px',
    _before: {
      display: 'none',
    },
  },
  rowWrapperWithBtn: {
    pb: '4',
  },
  tab: {
    bg: 'beta.700',
    color: 'alpha.400',
    fontSize: '2xs',
    fontWeight: 'extrabold',
    _first: { ml: '4px' },
    _last: { mr: '4px' },
    _notFirst: { borderLeftWidth: '1px', borderLeftColor: 'blackAlpha.400' },
    _selected: {
      bg: 'transparent',
      borderBottomColor: 'transparent',
      color: 'white',
    },
  },
};
